import { Grid, Paper, Typography } from "@material-ui/core";
import useText from "constants/text";
import React from "react";
import { formatAmount } from "utils";
import { getCashIcons, getCodeColorByCashStatus, getTextByCashStatus } from "../data";
import { ParcelIcon } from "../data/icons";
import { useHeaderStyles } from "../style";
import { CashcardProps } from "../types";


export const RecapCard : React.FC<CashcardProps> = ({status, amount, count, clickAction, activeCard, identifier, isParcelCount, isRmittance }) =>{
const classes = useHeaderStyles({color: getCodeColorByCashStatus(status), activeCard, identifier, isParcelCount});
const {text} = useText();
    return (
      <Paper className={classes.container} onClick={clickAction}>
        <Grid container spacing={0}>
          <Grid xs={isParcelCount ? 7 : 12} md={12}>
            <p>
              <span className={classes.icon}>{getCashIcons(status)}</span>{" "}
              <span className={classes.cardTitile}>{getTextByCashStatus(status, text, isRmittance)}</span>
            </p>
            <Typography className={classes.amount} variant="h2">
              {formatAmount(amount)}
            </Typography>
          </Grid>
          {isParcelCount && (
            <Grid xs={5} md={12}>
              <p className={classes.pStyled}>
                <ParcelIcon />{" "}
                <span className={classes.footer}>
                  {count} {text.all.parcels}
                </span>
              </p>
            </Grid>
          )}
        </Grid>
      </Paper>
    );
};
